import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

const Navbar = ({ currentPage, setCurrentPage }) => {
  const { t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: t('nav.home') },
    // { id: 'darshan', label: t('nav.darshan') },
    { id: 'about', label: t('nav.about') },
    { id: 'gallery', label: t('nav.gallery') },
    { id: 'tenders', label: t('nav.tenders') },
    { id: 'events', label: t('nav.events') },
    { id: 'committee', label: t('nav.committee') },
    { id: 'location', label: t('nav.location') },
    { id: 'aaras-download', label: t('nav.download') },
    { id: 'donation', label: t('nav.donation') },
    { id: 'contact', label: t('nav.contact') }
  ];

  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => handleNavClick('home')}>
          <Logo />
        </div>

        {/* Mobile only: center title & timings */}
        <div className="navbar-mobile-center" onClick={() => handleNavClick('home')}>
          <div className="navbar-mobile-title notranslate" translate="no">
            {/* श्रीनाथ म्हस्कोबा महाराज */}
            श्री देवनाथ म्हस्कोबा महाराज
          </div>
          {/* <div className="navbar-mobile-timings ">
            {t('home.morning')} | {t('home.evening')}
          </div> */}
        </div>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="navbar-timings-desktop">
          <div className="nav-timing-item">
            <span className="timing-label">{t('home.darshanTimings')}:</span>
            <div className="nav-hours">
              <span>{t('home.morning')}</span>
              <span className="separator">|</span>
              <span>{t('home.evening')}</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

